import React, { useEffect } from 'react';
import { Button, Overlay } from '@thd-olt-component-react/core-ui';
import { observer } from 'mobx-react-lite';
import { Pagination } from '@thd-olt-component-react/pagination';
import { useStore } from '../../../store/index';
import DesktopInviteCandidateTable from './DesktopInviteCandidateTable';
import MobileInviteCandidateTable from './MobileInviteCandidateTable';

const InviteCandidateModal = ({ candidateId }) => {

  const {
    bulkJobInvitationStore: {
      bulkJobInvitationOpen,
      toggleBulkJobInvitationOpen,
      fetchActiveJobPostings,
      inviteCandidateToBulkJobPostings,
      selectedJobIds,
      paginationInfo,
      page,
      sort,
      setPage
    }
  } = useStore();

  useEffect(() => {
    fetchActiveJobPostings(candidateId);
  }, [page, sort]);

  const handlePageChange = (p) => {
    setPage(p);
  };

  const handleClose = () => {
    toggleBulkJobInvitationOpen(false);
  };

  const handleSendInvitations = () => {
    handleClose();
    inviteCandidateToBulkJobPostings(candidateId);
  };

  return (
    <Overlay
      modalClass="p2p-overlay p2p-invite-candidate-modal__overlay"
      open={bulkJobInvitationOpen}
      onClose={handleClose}
      closeButton
      positionedCloseButton
    >
      {bulkJobInvitationOpen && (
        <div>
          <div className="p2p-invite-candidate-modal__orange-text">
            Choose which jobs you would like to invite this candidate to apply to
          </div>
          <div className="p2p-invite-candidate-modal__paragraph-text">
            <span>
              Inviting a candidate does not mean you are hiring them. After you
              send an invitation, you cannot undo the invitation.
              <br />
              The candidate
              will see your invitation, and can choose whether to decline it, or
              accept it and apply to the job. {' '}
            </span>
            <span className="p2p-invite-candidate-modal__bold-text">
              You can only invite candidates to currently
              <span className="p2p-invite-candidate-modal__green-text"> Active </span>
              jobs, if the
              candidates have not already been invited or applied.
            </span>
            <div className="p2p-invite-candidate-modal__space-text">
              Choose from your list of active job postings below.
            </div>
          </div>
          <div className="ptp-hidden__sm-up">
            <MobileInviteCandidateTable />
          </div>
          <div className="ptp-hidden__xs-down">
            <DesktopInviteCandidateTable />
          </div>
          {paginationInfo.totalPages !== 1 && (
            <div className="slm__pagination_container" data-testid="bulk-invitation-jobs-pagination">
              <Pagination
                showArrows
                maxNumericBlocks={window.innerWidth <= 600 ? 4 : 5}
                pagesBeforeDotsShow={5}
                totalPages={paginationInfo.totalPages}
                currentPage={paginationInfo.currentPage}
                onPageChanged={handlePageChange}
              />
            </div>
          )}
          <div className="p2p-invite-candidate-modal__buttons-container">
            <Button
              className="cancel-button"
              data-testid="close-bulk-invitation-modal"
              onClick={handleClose}
              style={{ fontWeight: '600', fontSize: '16px', width: '50px' }}
              link
            >
              Cancel
            </Button>
            <Button
              data-testid="send-bulk-invitations"
              onClick={handleSendInvitations}
              disabled={!selectedJobIds?.length}
              style={{ fontWeight: '600', fontSize: '16px', width: '250px' }}
            >
              Send Invitations
            </Button>
          </div>
        </div>
      )}
    </Overlay>
  );
};

export default observer(InviteCandidateModal);
